module.exports = __webpack_public_path__ + "static/media/arrow-enter.a084f51d.svg";